import UndoManager from "../undo/UndoManager";
import { AppCommandsManager } from "./commands/AppCommandsManager";
import { WebAppProject } from "./project/WebAppProject";
import { WebAppContextSelection as WebAppContextSelection } from "./selection/WebAppContextSelection";

export class WebApp<C,P extends WebAppProject> 
{
  protected _context:C;
  get context(){ return this._context; }

  protected _commandsManager:AppCommandsManager<C,P>;
  get commandsManager(){ return this._commandsManager; }

  protected _undoManager:UndoManager;
  get undoManager(){ return this._undoManager; }

  protected _project:P;
  get project():P{ return this._project; }

  protected _contextSelections:WebAppContextSelection[];
  get contextSelections(){ return this._contextSelections };

  get selection()
  {
    return this._contextSelections[ 0 ];
  }

  protected _contextID:string;
  get contextID()
  {
    return this._contextID;
  }

}